import { i18n } from '@/plugins/i18n';
import {
  HELP_LINKS_FF,
  BIZAI_CHAT_FF,
  DEFAULT_QUESTION_KEY,
  HELP_WORKFLOW_NAME,
} from '../constants/helpConstants';

// Store-free on purpose: businessStore uses it too (see ../README.md, "The store import cycle").

export function resolveHelpDestination(getters) {
  const hasFeature = getters['BusinessStore/hasFeature'];
  if (!hasFeature || !hasFeature(HELP_LINKS_FF)) return 'external';
  const isAdmin = getters['StaffStore/staffData']?.role === 'admin';
  return hasFeature(BIZAI_CHAT_FF) && isAdmin ? 'chat' : 'none';
}

export function buildHelpLaunch({ message = null, source = 'help_article' } = {}) {
  return {
    message: message || i18n.t(DEFAULT_QUESTION_KEY),
    context: { source },
    workflow: { name: HELP_WORKFLOW_NAME },
  };
}
